module.exports = __webpack_public_path__ + "img/644.18ffa669.png";